module.exports = __webpack_public_path__ + "img/icon_manejo_de_presupuesto.d2d1bea6.svg";